var MapLibreOverlay = /** @class */ (function () {
    function MapLibreOverlay(map, stations) {
        var _this = this;
        this.map = map;
        this.stations = stations;
        this.areLabelsShown = false;
        map.addSource('points', {
            type: 'geojson',
            data: this.geojson(),
        });
        map.addLayer({
            id: 'shadows',
            type: 'circle',
            source: 'points',
            paint: {
                'circle-radius': 10,
                'circle-color': '#000000',
                'circle-opacity': ['+', 0.05, ['get', 'visible']],
            },
        });
        map.addLayer({
            id: 'points',
            type: 'circle',
            source: 'points',
            paint: {
                'circle-radius': 10,
                'circle-color': ['concat', '', ['get', 'color']],
                'circle-opacity': ['+', 0, ['get', 'visible']],
            },
        });
        map.addLayer({
            id: 'values',
            type: 'symbol',
            source: 'points',
            layout: {
                'text-field': ['concat', '', ['get', 'label']],
                'text-font': ['Open Sans Semibold', 'Arial Unicode MS Bold'],
                'text-size': 10,
            },
            paint: {
                'text-color': 'white',
            },
        });
        map.setLayoutProperty('values', 'visibility', 'none');
        map.on('mousemove', 'points', function (e) {
            var selection = stations.findFromLatLng(e.lngLat);
            stations.highlight(selection, function (x) { return map.project(x); });
        });
        map.on('mouseleave', 'points', function (e) {
            stations.highlight([], function (x) { return e.point; });
        });
        var pzoom = 0;
        map.on('zoom', function (e) {
            var z = Math.round(10 * map.getZoom()) / 10;
            if (z == pzoom)
                return;
            pzoom = z;
            _this.updateZoom();
        });
    }
    MapLibreOverlay.prototype.updateZoom = function () {
        var map = this.map;
        var z = map.getZoom();
        if (z < 3) {
            z = Math.max(2, 3 - (3 - z) * 2);
            map.setPaintProperty('shadows', 'circle-radius', z + 0.2);
            map.setPaintProperty('points', 'circle-radius', z);
        }
        else {
            var shadowRadius = Math.max(0.2, Math.min(1, (z - 3) / 2));
            map.setPaintProperty('shadows', 'circle-radius', shadowRadius + z);
            map.setPaintProperty('points', 'circle-radius', z);
        }
        if (z < 8.8) {
            if (this.areLabelsShown) {
                map.setLayoutProperty('values', 'visibility', 'none');
                this.areLabelsShown = false;
            }
        }
        else {
            if (!this.areLabelsShown) {
                map.setLayoutProperty('values', 'visibility', 'visible');
                this.areLabelsShown = true;
            }
        }
    };
    MapLibreOverlay.prototype.geojson = function () {
        var _this = this;
        return {
            type: 'FeatureCollection',
            features: this.stations.stations.map(function (x) {
                var AQI = x.AQI;
                return {
                    type: 'Feature',
                    geometry: {
                        type: 'Point',
                        coordinates: [x.geo.lng, x.geo.lat],
                    },
                    properties: {
                        aqi: AQI,
                        label: x.isOutdated ? '-' : AQI,
                        color: x.color(),
                        zoom: _this.map.getZoom(),
                        visible: x.isHighlighted ? 1 : x.isVisible ? (x.isOutdated ? .0 : 1) : 0,
                    },
                    id: x.idx,
                };
            }),
        };
    };
    MapLibreOverlay.prototype.refresh = function () {
        var source = this.map.getSource('points');
        source.setData(this.geojson());
        this.updateZoom();
    };
    return MapLibreOverlay;
}());
export { MapLibreOverlay };
